// Modules
import React, { useEffect, useState } from 'react'
import { Redirect, useHistory } from 'react-router-dom'

// Application
import { ROUTES_PATH } from 'constants/index'
import { useSignUp } from 'context'
import { useSignUpStepper } from 'redesign/hooks/useSignUpStepper'
import { PatientInfoInput } from 'typings/signup'
import { convertToNumber, formattedBirthDateUSA, isEmpty } from 'utils'
import { useSignUpAnaytics } from 'hooks/useSignUpAnaytics'

// Components
import { TemplateContainer } from 'components'
import { SignUpHeader as Header } from 'redesign/components/organisms'
import { Wrapper } from './components'
import { SignUpModal } from 'redesign/components/molecules/SignUpModal'
import { SignUpHelpTextModal } from 'redesign/components/atoms/SignUpHelpTextModal'

export const SNPhone = () => {
    const [showModal, setShowModal] = useState(false)
    const history = useHistory()
    const {
        hasMounted,
        hasSeenFirstStep,
        setContactPhone,
        createPatientAccount,
        setIsLoading,
        personalData,
        contact,
        passwords,
        userId,
        validateLoginContact,
    } = useSignUp()
    const { setStepValue } = useSignUpStepper()

    const shouldRedirect =
        !personalData?.cpf || !personalData?.biologicalSex || !passwords?.password || !isEmpty(userId) || !hasSeenFirstStep

    useSignUpAnaytics({
        defaultDispatchEvent: 'setPhoneOnOpen',
        shouldCall: hasMounted && !shouldRedirect,
    })

    useEffect(() => {
        setStepValue(2)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (!hasMounted) {
        return null
    }

    const patient: PatientInfoInput = {
        birthDate: formattedBirthDateUSA(personalData?.birthDate),
        cellphone: convertToNumber(contact?.cellphone?.value),
        email: contact?.email?.value,
        cpf: convertToNumber(personalData?.cpf),
        biologicalSex: personalData?.biologicalSex,
        genderIdentity: personalData?.genderIdentity,
        name: personalData?.name,
        socialName: personalData?.socialName,
        password: passwords?.password,
        ...(personalData?.anonymousPatient && { anonymousPatient: true }),
    }

    if (shouldRedirect) {
        return <Redirect to={ROUTES_PATH.SIGN_UP_PERSONAL_DATA} />
    }

    return (
        <TemplateContainer>
            <Header showStepper subtitle="Para utilizar nossos serviços precisamos validar seu celular." title="Qual é seu celular?" />
            <SignUpModal
                setShowModal={() => {
                    setShowModal(!showModal)
                }}
                showModal={showModal}
                title="Por que preciso informar meu celular?"
            >
                <p>
                    Enviarei um código para o número de celular informado para fazer a validação da sua conta, assim seus dados ficam
                    mais seguros.
                </p>
            </SignUpModal>
            <SignUpHelpTextModal onClick={() => setShowModal(true)}>Por que preciso informar meu celular?</SignUpHelpTextModal>
            <Wrapper
                cellphone={contact?.cellphone}
                createPatientAccount={createPatientAccount}
                history={history}
                patient={patient}
                setContactPhone={setContactPhone}
                setIsLoading={setIsLoading}
                validateLoginContact={validateLoginContact}
            />
        </TemplateContainer>
    )
}
